import React, { useState } from "react";
import {
    NavLink as NavLinkRRD,
    Link,
    useLocation,
    useHistory,
} from "react-router-dom";
import Image from "../../assets/img/sidebar.png";
import { Collapse, Navbar, NavItem, NavLink, Nav } from "reactstrap";
import Modal from "components/Modal/Modal";
import { useCookies } from "react-cookie";

import "assets/css/custom.css";

function Sidebar({ routes }) {
    const [, , removeCookie] = useCookies(["userToken", "userRole"]);

    // Modal
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = () => {
        removeCookie("userToken", { path: "/" });
        removeCookie("userRole", { path: "/" });
        setIsOpen(false);
        history.replace("/");
    };

    const history = useHistory();
    const location = useLocation();
    const userRole = location.pathname.split("/")[1];
    // this function creates the links and collapses that appear in the sidebar (left menu)
    const createLinks = (routes) => {
        return routes.map((prop, key) => {
            if (prop.redirect || prop.notSideBar) {
                return null;
            }

            return (
                <NavItem key={key}>
                    <NavLink
                        to={prop.layout + prop.path}
                        tag={NavLinkRRD}
                        style={{ color: "#F8F8F8" }}
                    >
                        {prop.icon !== undefined ? (
                            <div style={{ marginBottom: "1.5vw" }}>
                                <i
                                    className={prop.icon}
                                    style={{
                                        marginRight: "1vw",
                                        fontSize: "1.5rem",
                                    }}
                                />
                                <span style={{ fontSize: "1.1rem" }}>
                                    {prop.name}
                                </span>
                            </div>
                        ) : (
                            prop.name
                        )}
                    </NavLink>
                </NavItem>
            );
        });
    };

    return (
        <>
            <Navbar
                style={{
                    position: "fixed",
                    top: 0,
                    padding: 0,
                    margin: 0,
                }}
            >
                <div
                    className="pt-5"
                    style={{
                        background: `url(${Image})`,
                        backgroundSize: "cover",
                        height: "100vh",
                        width: "250px",
                    }}
                >
                    <div className="pb-5 pl-5">
                        <Link
                            to={
                                userRole === "admin"
                                    ? "/admin/companies"
                                    : "/company/shops"
                            }
                        >
                            <h1 style={{ color: "#F8F8F8", fontSize: 30 }}>
                                GTOaaS
                                <br />
                                <span style={{ fontSize: 20 }}>
                                    {userRole === "admin"
                                        ? "ADMIN PORTAL"
                                        : "COMPANY PORTAL"}
                                </span>
                            </h1>
                        </Link>
                    </div>
                    <div className="pl-5">
                        <Collapse navbar isOpen={true}>
                            <Nav navbar>{createLinks(routes)}</Nav>
                        </Collapse>
                    </div>
                    <hr color="white" />

                    <div className="pl-5">
                        <Collapse navbar isOpen={true}>
                            <Nav navbar>
                                <div
                                    to=""
                                    style={{
                                        color: "#F8F8F8",
                                        cursor: "pointer",
                                    }}
                                    tag={NavLinkRRD}
                                    onClick={() => setIsOpen(true)}
                                >
                                    <i
                                        className={"ni ni-single-02"}
                                        style={{
                                            marginRight: "1vw",
                                            fontSize: "1.5rem",
                                        }}
                                    />
                                    <span style={{ fontSize: "1.1rem" }}>
                                        Logout
                                    </span>
                                </div>
                            </Nav>
                        </Collapse>
                    </div>
                </div>
            </Navbar>
            <Modal
                isOpen={isOpen}
                title="Confirm Log Out"
                description="Do you wish to log out?"
                handleClose={handleClose}
                handleConfirm={handleConfirm}
            />
        </>
    );
}

export default Sidebar;
